import { GalleryI } from "@/interfaces/galleries/Galleries";
import "./SubscriptionCard.scss";
import { handleImageError } from "@/utils/GalleryFunctions";
import Link from "next/link";
import { nameSlug } from "@/utils/Functions/NameSlug";

interface SubscriptionCardPropsI {
  gallery: GalleryI;
}

function SubscriptionCard(props: SubscriptionCardPropsI) {
  const { gallery } = props;
  return (
    <div className="subscription-card-component-main-container">
      <Link href={`/${nameSlug(gallery.name)}`}>
        <h2>{gallery.name}</h2>
      </Link>
      <div className="author-info font-bold">
        <img
          src={gallery.authorId.avatar}
          onError={handleImageError}
          alt={gallery.authorId.name}
        />
        <p className="font-light">By {gallery.authorId.name}</p>
        <p className="photos-counter font-bold">{gallery.photos} photos</p>
      </div>
    </div>
  );
}

export default SubscriptionCard;
